import { DatePicker, Input, Table, Modal, Button } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";

class SwapRound extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getList());
  };

  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.swaptalkRoundList,[10,pageNum],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        tables: res.data.list,
        pagination,
      });
    });
  };
  getRoundFromDate = date => {
    return moment(date, 'YYYYMMDDHHmm').hour() * 60 + moment(date, 'YYYYMMDDHHmm').minute();
  }
  render() {
    const { tables } = this.state;
    const columns = [
        {
          title: "날짜",
          dataIndex: "gameTime",
          className: "support-column-number fs-15 lh-21",
          render: value => moment(value, 'YYYYMMDD').format('YYYY-MM-DD')
        },
        {
          title: "회차",
          dataIndex: "gameTime",
          className: "support-column-number fs-15 lh-21",
          render: value => this.getRoundFromDate(value)
        },
        {
          title: "기준가격",
          dataIndex: "basePrice",
          className: "support-column-number fs-15 lh-21",
          render: value => numberFormat(value)
        },
        {
          title: "결과가격",
          dataIndex: "resultPrice",
          className: "support-column-number fs-15 lh-21",
          render: value => numberFormat(value)
        },
        {
          title: "결과",
          dataIndex: "result",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "참가지수",
          dataIndex: "count",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "UP선택",
          dataIndex: "upCount",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "DOWN선택",
          dataIndex: "downCount",
          className: "support-column-number fs-15 lh-21",
        },
        {
          title: "UP비율",
          dataIndex: "upCount",
          className: "support-column-number fs-15 lh-21",
          render: (value, row) => (row.upCount+row.downCount == 0 ? 0 : Math.floor(row.upCount / (row.upCount+row.downCount)*10000) / 100) + ' %'
        },
        {
          title: "평균수수료",
          dataIndex: "feeRatioAverage",
          className: "support-column-number fs-15 lh-21",
          render: (value, row) => (Math.floor(value*100) / 100) + ' %'
        },
        {
          title: "수수료총액(USDT)",
          dataIndex: "feeTotal",
          className: "support-column-number fs-15 lh-21",
          render: value => numberFormat(Math.floor(value/1000000))
        },

    ];

    return (
      <div>
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          라운드 내역
      </div>
        <div className="wrapper mt-35 width-1240" />
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.deleted ? "gray" : "")}
          dataSource={tables}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default SwapRound;
